import axios from 'axios';

import {API_URL} from './constants';

type ConfirmRegistrationOptions = {
    token: string;
    password: string;
    confirmPassword: string;
}

const validateToken = (token: string) => axios.post(`${API_URL}/registration/validate-token`, {token});

const sendRegistrationLink = (email: string) => axios.post(`${API_URL}/registration/send-registration-link`, {email});

const confirmCreateUser = (options: ConfirmRegistrationOptions) => axios.post(`${API_URL}/registration/user/complete`, options);

export const registrationApi = {
    validateToken,
    sendRegistrationLink,
    confirmCreateUser
};
